import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API, BASE_XHH} = extractAPIValues()

// 获取加速器下载链接
export function getAccDownloadUrl (args) {
	let url = BASE_API + '/chatroom/v2/settings/acc/download_url'
	return axiosGetHandler(url, args)
}

// 获取小黑盒表情列表，等后台兼容语音请求后使用
export function getHeyboxEmojis (args) {
	let url = BASE_XHH + '/bbs/app/api/emojis/list'
	return axiosGetHandler(url, {
		emoji_version: 'd751713988987e9331980363e24189c1'
	})
}

// 获取全局开关配置
export function getGlobalConfig (args) {
	let url = BASE_API + '/chatroom/v2/common/global';
	return axiosGetHandler(url, args)
}